export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/loading.d03d06a.gif";